import { gql } from '@apollo/client/core';

//getGroupsQuery
export const getProviderGroupsQuery = gql`
  query GetProviderGroups(
    $first: Int!
    $where: ProviderGroupFilterInput
    $order: [ProviderGroupSortInput!]
    $after: String
    $accountName: String
  ) {
    providerGroups(
      first: $first
      where: $where
      order: $order
      after: $after
      accountName: $accountName
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        accountNumber
        addressCity
        addressLine1
        addressLine2
        addressState
        addressZipcode
        alphaII
        appSenderCode
        backLink
        batch277ca
        batch277u
        batchCSV
        batchHumanReadable
        batchMachineReadable
        batchXml
        # billingIds{
        #   billingId
        #   billingIdType
        #   billingIdTypeCode
        #   dateLastDbUpdate
        #   dateSetup
        #   lastUpdatedBy
        #   name
        #   notes
        #   providerGroup
        #   providerGroupId
        #   providerId
        #   rowId
        #   status
        # }
        billingMethod
        certified
        claimStatusDate
        claimStatusStatus
        clientVersion
        combineERA
        contactEmail
        contactFax
        contactName
        contactPhone
        contactTitle
        dateLastCertified
        dateLastClaim
        dateLastDbUpdate
        dateSetup
        dateTerminated
        ecsDate
        ecsStatus
        eligibilityDate
        eligibilityStatus
        eraDate
        eraFileSeqNum
        eraStatus
        feeSchedule
        ftpKey
        glueEM
        groupId
        humanReadable271
        instAppSenderCode
        instNM109IdCode
        instProcessorId
        instSubmitterId
        interchangeNum
        lastUpdatedBy
        lockBox
        lockboxProcessorId
        mailboxId
        name
        newStatements
        nm109IdCode
        notes
        organizationType
        pmIdentifier
        accountCredentialKey
        pms
        pmsSoftware
        processorId
        providers {
          id
          lastName
          firstName
          organizationType
          organizationName
          recordStatus
          providerGroupId
          accountNumber

          contactEmail
          contactFax
          contactName
          contactPhone
          contactTitle

          addressCity
          addressLine1
          addressLine2
          addressState
          addressZipcode
        }
        recordStatus
        rejectPrintClaims
        remit277ca
        remit277u
        remitCsv
        remitCSVDaily
        # remitERASummary
        remitHumanReadable
        remitMachineReadable
        remitXml
        reportNumber
        statementDate
        statementMethod
        statementStatus
        submitterId
        inputGenerates999
        universalReport
        partialRedirectProfessional
        partialRedirectInstitutional
        genericProvider
        accountCredentialKey
        allowACH
        achCredentialKey
      }
    }
  }
`;

export const getProviderGroupQuery = gql`
  query providerGroup($groupId: String) {
    providerGroup(id: $groupId) {
      accountNumber
      addressCity
      addressLine1
      addressLine2
      addressState
      addressZipcode
      alphaII
      appSenderCode
      backLink
      batch277ca
      batch277u
      batchCSV
      batchHumanReadable
      batchMachineReadable
      batchXml
      billingIds {
        billingId
        billingIdTypeCode
        rowId
        name
      }
      billingMethod
      certified
      claimStatusDate
      claimStatusStatus
      clientVersion
      combineERA
      contactEmail
      contactFax
      contactName
      contactPhone
      contactTitle
      dateLastCertified
      dateLastClaim
      dateLastDbUpdate
      dateSetup
      dateTerminated
      ecsDate
      ecsStatus
      eligibilityDate
      eligibilityStatus
      eraDate
      eraFileSeqNum
      eraStatus
      feeSchedule
      ftpKey
      glueEM
      groupEnrollments {
        id
        taxId
        processorId
        npi
        pms
      }
      groupId
      humanReadable271
      instAppSenderCode
      instNM109IdCode
      instProcessorId
      instSubmitterId
      interchangeNum
      isDev
      lastUpdatedBy
      lockBox
      lockboxProcessorId
      mailboxId
      name
      newStatements
      nm109IdCode
      notes
      organizationType
      pmIdentifier
      accountCredentialKey
      pms
      pmsSoftware
      processorId
      providers {
        id
        lastName
        firstName
        organizationName
        recordStatus
        providerGroupId
      }
      recordStatus
      rejectPrintClaims
      remit277ca
      remit277u
      remitCsv
      remitCSVDaily
      remitHumanReadable
      remitMachineReadable
      remitXml
      reportNumber
      statementDate
      statementMethod
      statementStatus
      submitterId
      universalReport
      usersClientsGrps {
        id
        userClientId
      }
      inputGenerates999
      rCM
      partialRedirectProfessional
      partialRedirectInstitutional
      genericProvider
      accountCredentialKey
      allowACH
      achCredentialKey
    }
  }
`;

export const getProviderGroupDataForProviderQuery = gql`
  query providerGroupDataForProvider($groupId: String) {
    providerGroup(id: $groupId) {
      accountNumber
      groupId
      pms
      feeSchedule
      certified
      addressCity
      addressLine1
      addressLine2
      addressState
      addressZipcode
      contactEmail
      contactFax
      contactName
      contactPhone
      contactTitle
      ecsStatus
      ecsDate
      eraStatus
      eraDate
      claimStatusDate
      claimStatusStatus
      eligibilityDate
      eligibilityStatus
      statementDate
      statementStatus
    }
  }
`;

export const getProviderGroupQueryByAccounts = gql`
  query GetProviderGroups(
    $first: Int!
    $where: ProviderGroupFilterInput
    $order: [ProviderGroupSortInput!]
    $after: String
  ) {
    providerGroups(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        groupId
        name
      }
    }
  }
`;

export const getProviderGroupQueryByAccountsUser = gql`
  query GetProviderGroups($accountIds: [String]) {
    userGroupsByAccount(accountIds: $accountIds) {
      firstName
      userName
      lastName
      groupIds {
        id
        userClientId
        groupId
        group {
          groupId
          name
        }
      }
    }
  }
`;
